export {
  adminRouteConfig as adminRoutes,
  adminNavConfig as adminNav,
  renterRouteConfig as renterRoutes,
  renterNavConfig as renterNav
} from './_nav';

